import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import { FLOW_SCREEN_PERMISSIONS } from '../../../../routes/dashboard/settings/automationFlows/automationFlows.routes';
import {
  BOT_MANAGE_PERMISSIONS,
  BOT_CREATE_PERMISSIONS,
  BOT_EDIT_PERMISSIONS,
  BOT_DELETE_PERMISSIONS,
  BOT_KNOWLEDGE_MANAGE_PERMISSIONS,
  ROLES,
  SCHEDULED_MESSAGE_VIEW_PERMISSIONS,
  CANNED_RESPONSE_MANAGE_PERMISSIONS,
  CANNED_RESPONSE_CREATE_PERMISSIONS,
  CANNED_RESPONSE_EDIT_PERMISSIONS,
  CANNED_RESPONSE_DELETE_PERMISSIONS,
} from 'dashboard/constants/permissions.js';

const automations = accountId => ({
  parentNav: 'automations_nav',
  routes: [
    'config_chat_bots',
    'automation_flows_list',
    'automation_flows_new',
    'automation_flows_edit',
    // Visualização somente leitura de uma versão (#1705): mesma seção do menu.
    'automation_flows_version',
    'scheduled_messages_settings',
    'canned_list',
    'settings_meta_leadgen',
  ],
  menuItems: [
    {
      icon: 'settings',
      label: 'BOTS_AND_AI',
      key: 'config_chat_bots',
      hasSubMenu: false,
      featureFlag: FEATURE_FLAGS.AGENT_BOTS,
      meta: {
        permissions: [
          'administrator',
          BOT_MANAGE_PERMISSIONS,
          BOT_CREATE_PERMISSIONS,
          BOT_EDIT_PERMISSIONS,
          BOT_DELETE_PERMISSIONS,
          BOT_KNOWLEDGE_MANAGE_PERMISSIONS,
        ],
      },
      toState: frontendURL(
        `accounts/${accountId}/automations/chat-bots/config`
      ),
      toStateName: 'config_chat_bots',
    },
    {
      icon: 'flash-on',
      label: 'AUTOMATION_FLOWS',
      key: 'automation_flows',
      hasSubMenu: false,
      // Sem featureFlag desde #728: o motor de fluxos deixou de ser gateado, e
      // esconder o item por bit deixaria a conta sem nenhuma tela de automação
      // depois do corte do legado.
      meta: {
        permissions: FLOW_SCREEN_PERMISSIONS,
      },
      toState: frontendURL(`accounts/${accountId}/automations/flows/list`),
      toStateName: 'automation_flows_list',
    },
    {
      icon: 'megaphone',
      label: 'META_LEADGEN_MENU',
      key: 'meta_leadgen',
      hasSubMenu: false,
      featureFlag: FEATURE_FLAGS.META_LEADGEN,
      meta: {
        permissions: ['administrator'],
      },
      toState: frontendURL(`accounts/${accountId}/settings/meta-leadgen`),
      toStateName: 'settings_meta_leadgen',
    },
    {
      icon: 'calendar-clock',
      label: 'SCHEDULED_MESSAGES',
      key: 'scheduled_messages',
      hasSubMenu: false,
      meta: {
        permissions: [...ROLES, SCHEDULED_MESSAGE_VIEW_PERMISSIONS],
      },
      toState: frontendURL(
        `accounts/${accountId}/automations/scheduled-messages`
      ),
      toStateName: 'scheduled_messages_settings',
    },
    {
      icon: 'chat-multiple',
      label: 'CANNED_RESPONSES',
      key: 'canned_responses',
      hasSubMenu: false,
      meta: {
        permissions: [
          'administrator',
          CANNED_RESPONSE_MANAGE_PERMISSIONS,
          CANNED_RESPONSE_CREATE_PERMISSIONS,
          CANNED_RESPONSE_EDIT_PERMISSIONS,
          CANNED_RESPONSE_DELETE_PERMISSIONS,
        ],
      },
      toState: frontendURL(
        `accounts/${accountId}/automations/canned-response/list`
      ),
      toStateName: 'canned_list',
      featureFlag: FEATURE_FLAGS.CANNED_RESPONSES,
    },
  ],
});

export default automations;
